import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { environment } from 'src/environments/environment';
import { CreateAccountModel, LoginAccountModel, LoginAccountResult } from '../Elearning-Models';
import { IServiceFactory } from '../Services/service-factory';
import { CreateAccountService } from '../Services/create-account.service';
import { Form } from '@angular/forms';

@Component({
  selector: 'app-consumer-curriculum-login',
  templateUrl: './consumer-curriculum-login.component.html',
  styleUrls: ['./consumer-curriculum-login.component.scss']
})
export class ConsumerCurriculumLoginComponent implements OnInit {
  createAccount: CreateAccountModel;
  dataService: CreateAccountService;
  passwordHide = true;
  imagePath = environment.imagePath;

  returnURL: string;

  constructor(
    private toastr: ToastrService,
    private serviceFactory: IServiceFactory,
    private activatedRoute: ActivatedRoute,
    private router: Router
  ) {
    this.createAccount = new CreateAccountModel();
    this.dataService = this.serviceFactory.getCreateAccountService();
  }

  ngOnInit(): void {
    this.returnURL = this.activatedRoute.snapshot.queryParams['ReturnUrl'];

    // if(!this.returnURL){
    //   this.dataService.IsLoggedIn().subscribe( result => {
    //     if(result.LoggedIn){
    //       window.location.href = '/ELearning/Course';
    //     }
    //   });
    // }
  }

  login(){
    

    var model = new LoginAccountModel()
    model.Email = this.createAccount.Email ?? "";
    model.Password = this.createAccount.Password ?? "";

    if (!model.Email){
      return;
    }

    if (!model.Password){
      return;
    }

    this.dataService.LoginUser(model).subscribe(result=>{
      if (result && result.isLoggedIn){
        //environment.rootPath +   - don't need this?
        window.location.href = this.returnURL ?? '/ELearning/Course';
      } else {
        this.toastr.error("Please try again.","Could not login")
      }
    });
  }

  createNewAccount(){
    this.router.navigate([environment.rootPath + 'User']);
  }

  EnterSubmit($event){
    if($event.keyCode === 13){
      this.login();
    }
  }

}
